import * as React from 'react';
import { Text } from '@chakra-ui/react';
import {
  UploadActions,
  UploadButtonSection,
  UploadExample,
  UploadComplete as UploadCompleteSection,
  AcknowledgeBox,
  ModalColumns
} from 'shared-components';
import placeholderExample from '../../../../assets/images/sample-academic-transcript.jpg';

interface IProps {
  lastCourseYear: string;
  lastCourseName: string;
  complete: boolean;
  fileNames: string[];
  onContinue: () => void;
  onUpload: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle: string,
    fileNames: string[]
  ) => void;
  onClose: () => void;
  docKey: string;
  infoOnly: boolean;
  docStatus: string;
  onAcknowledgeToggle: (status: string) => void;
}

const AcademicTranscriptModal: React.FC<IProps> = (props: IProps) => {
  const { lastCourseName, lastCourseYear, docKey, infoOnly, docStatus } = props;

  const handleUpload = () => {
    props.onUpload(null, null, 'academicTranscript', docKey, 'Academic Transcript', props.fileNames);
  };

  const handleOnClose = () => {
    if (docStatus === 'INFO_ONLY') {
      props.onAcknowledgeToggle('NOT_ACKNOWLEDGED');
    }
    props.onClose();
  };

  const toggleAcknowledge = (key: string, value: boolean) => {
    // prevent call to API if previous call not yet complete
    if ((value === true && docStatus !== 'ACKNOWLEDGED') || (value === false && docStatus === 'ACKNOWLEDGED')) {
      props.onAcknowledgeToggle(value === true ? 'ACKNOWLEDGED' : 'NOT_ACKNOWLEDGED');
    }
  };

  return (
    <ModalColumns
      id={'transcript'}
      title={'Upload Academic History - Transcript'}
      onClose={handleOnClose}
      supportingColumn={<UploadExample altText="Academic transcript example" url={placeholderExample} />}
    >
      {infoOnly ? (
        <>
          <Text>
            During your visa application you may be required to provide a scan of the final grades you achieved for your{' '}
            {lastCourseName} in {lastCourseYear}.
          </Text>

          <AcknowledgeBox
            id={docKey}
            blurb="Please confirm you have read and understand the above."
            isTicked={docStatus === 'ACKNOWLEDGED'}
            onChange={toggleAcknowledge}
          />

          <UploadActions
            complete={docStatus === 'ACKNOWLEDGED'}
            onContinue={handleOnClose}
            label="Return to document upload"
          />
        </>
      ) : (
        <>
          {props.complete ? (
            <UploadCompleteSection fileNames={props.fileNames} onUpload={handleUpload} onContinue={props.onContinue} />
          ) : (
            <>
              <Text>
                You must upload a scan of the final grades you achieved for your {lastCourseName} in {lastCourseYear}.
              </Text>

              <UploadButtonSection onUpload={handleUpload}>
                Awaiting upload of <b>Academic History - Transcript</b>
              </UploadButtonSection>

              <UploadActions showEmail={false} complete={props.complete} onContinue={props.onContinue} />
            </>
          )}
        </>
      )}
    </ModalColumns>
  );
};

export default AcademicTranscriptModal;
